import { Component, Emit, Inject, Prop } from 'vue-property-decorator';
import { FiltroParticipacion } from '@/shared/model/filtro-participacion.model';
import { RolAutoridad } from '@/shared/model/enumerations/rol-autoridad.model';
import ParticipanteService from '@/components/participantes/participante.service';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { StatusCodes } from 'http-status-codes';
import { mixins } from 'vue-class-component';
import { Alumno, MenuFuncion, ParticipacionSnp as ParticipacionProfesorSnp, ProfesorAlumnoSnp } from '@/shared/model/snp/claustro.model';
import { ParticipacionSnp as ParticipacionAlumnoSnp } from '@/shared/model/snp/alumno.model';
import CatalogosSnp from '@/shared/model/snp/catalogos-snp.factory';
import { BvTableFieldArray } from 'bootstrap-vue';
import PermisosSnpMixin from '@/entities/snp/permisos/permisos-snp.mixin';
import ApeironComponent from '@/components/commons/apeiron-component.model';

@Component({})
export default class ClaustroAsociarAlumnosComponent extends mixins(PermisosSnpMixin, ApeironComponent) {
  @Inject('participanteService') private readonly participanteService: () => ParticipanteService;

  @Prop({ required: true })
  public readonly solucion: Solucion;

  @Prop({ required: true })
  public readonly solicitud: Solicitud;

  @Prop({ required: true })
  public permisos: any;

  @Prop({ required: true })
  public formModel: any;

  @Prop({ required: true })
  public readonly participacionProfesor: ParticipacionProfesorSnp;

  public alumnos: Array<Alumno> = [];

  public opcionesFuncion: Array<MenuFuncion> = [];

  public filtroAlumno = '';
  public perPage = 15;
  public currentPage = 1;
  public totalRows = 0;
  public readonly pageOptions: Array<number> = [1, 2, 5, 15, 25, 50, 100, 150];
  public mostrarModalAsociarAlumnos = false;
  public showLoading = false;

  public readonly fieldsAlumnos: BvTableFieldArray = [
    {
      key: 'cvu',
      label: this.$t('apeironGwApp.claustroSnp.modalAsociar.cvuAlumno').toString(),
      class: 'text-center',
    },
    {
      key: 'participante',
      label: this.$t('apeironGwApp.claustroSnp.modalAsociar.nombreAlumno').toString(),
      class: 'text-center',
    },
    { key: 'asociado', label: this.$t('apeironGwApp.claustroSnp.modalAsociar.asociado').toString(), class: 'text-center' },
    { key: 'asociar', label: this.$t('apeironGwApp.claustroSnp.modalAsociar.funcionRelacion').toString(), class: 'text-center' },
    { key: 'baja', label: this.$t('apeironGwApp.claustroSnp.modalAsociar.activo').toString(), class: 'text-center' },
    { key: 'acciones', label: this.$t('apeironGwApp.claustroSnp.acciones.acciones').toString(), class: 'text-center' },
  ];

  public mounted(): void {
    this.iniciarComponente();
  }

  public cambiarPagina(pagina): void {
    this.currentPage = pagina;
    this.obtenerAlumnosPrograma();
  }

  public buscarDesdePrimerPagina(): void {
    this.currentPage = 1;
    this.obtenerAlumnosPrograma();
  }

  public iniciarComponente(): void {
    this.opcionesFuncion = [];
    CatalogosSnp.obtenerFuncion().forEach(funcion => {
      this.opcionesFuncion.push(MenuFuncion.fromObject(funcion));
    });
    this.mostrarModalAsociarAlumnos = false;
  }

  public mostrarModal(): void {
    this.mostrarModalAsociarAlumnos = true;

    this.obtenerAlumnosPrograma();
  }

  public obtenerAlumnosPrograma(): void {
    this.showLoading = true;
    this.obtenerProfesor().then(profesor => {
      const filtroPart: FiltroParticipacion = {
        solicitudId: this.solicitud.id,
        rol: RolAutoridad.ALUMNO,
        like: this.filtroAlumno,
      };

      const paginationQuery = {
        page: this.currentPage - 1,
        size: this.perPage,
        sort: ['participante.nombre,asc', 'participante.apellidoPaterno,asc', 'participante.apellidoMaterno,asc'],
        filter: filtroPart,
      };
      this.participanteService()
        .obtenerParticipaciones(paginationQuery)
        .then(res => {
          this.alumnos = [];
          (res.data ?? []).forEach(item => {
            const participacion = ParticipacionAlumnoSnp.fromObject(item);
            const alumno: Alumno = {
              idParticipacion: participacion?.id,
              apellidoMaterno: participacion?.participante?.apellidoMaterno,
              apellidoPaterno: participacion?.participante?.apellidoPaterno,
              cvu: participacion?.participante?.cvu,
              nombre: participacion?.participante?.nombre,
              valido: true,
              activo:
                (!item.participante.fechaBaja || (item.participante.fechaBaja && item.participante.reincorporacion)) &&
                !item.participante.obtencionGrado,
            };
            const alumnoAsociado = (profesor.profesorSnp?.alumnos ?? []).find(asociado => asociado.cvu == alumno.cvu);

            if (alumnoAsociado) {
              alumno.asociado = alumnoAsociado.asociado;
              alumno.relacion = alumnoAsociado.relacion;
            }

            this.alumnos.push(alumno);
          });
          this.totalRows = Number(res.headers['x-total-count']);
        })
        .catch(err => {
          if (err.response.data.status !== StatusCodes.NOT_FOUND) {
            this.alertService().showHttpError(this, err.response);
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    });
  }

  /**
   * Guarda las asociaciones de los alumnos
   */
  public async guardarAsociaciones() {
    if (this.alumnos.some(alumno => alumno.asociado && alumno.relacion == undefined)) {
      this.alertService().showError(this, this.$t('apeironGwApp.claustroSnp.modalAsociar.errorGuardarSeccion').toString());
      return;
    }

    await this.validarRelaciones();
    if (this.alumnos.some(alumno => alumno.asociado && !alumno.valido)) {
      return;
    }

    this.showLoading = true;
    this.obtenerProfesor()
      .then(profesor => {
        this.alumnos.forEach(alumno => {
          const alumnoAsociado = (profesor.profesorSnp?.alumnos ?? []).find(asociado => asociado.cvu == alumno.cvu);
          if (alumnoAsociado) {
            if (alumno.relacion == undefined) {
              profesor.profesorSnp.alumnos = (profesor.profesorSnp?.alumnos ?? []).filter(
                alumnoItem => alumnoItem.cvu != alumnoAsociado.cvu
              );
            } else {
              alumnoAsociado.relacion = alumno.relacion;
              alumnoAsociado.asociado = alumno.asociado;
            }
          } else if (alumno.relacion != undefined && alumno.asociado != undefined) {
            profesor.profesorSnp.alumnos ??= [];
            profesor.profesorSnp?.alumnos.push(alumno);
          }
        });
        this.participanteService()
          .update(profesor)
          .then(() => {
            this.alertService().showSuccess(this, this.$t('apeironGwApp.claustroSnp.modalAsociar.alumnosGuardados').toString());
            this.obtenerAlumnosPrograma();
            this.emitirCambio();
            this.mostrarModalAsociarAlumnos = false;
          })
          .catch(err => {
            this.alertService().showHttpError(this, err.response);
          })
          .finally(() => {
            this.showLoading = false;
          });
      })
      .catch(err => {
        if (err.response.data.status !== StatusCodes.NOT_FOUND) {
          this.alertService().showHttpError(this, err.response);
        }
      });
  }

  /**
   * Valida las relaciones de los alumnos asociados
   * @returns {Promise<void>}
   */
  private async validarRelaciones(): Promise<void> {
    const validaciones = this.alumnos
      .filter(alumno => alumno.asociado && alumno.relacion)
      .map(async alumno => {
        try {
          const profesores = await this.obtenerProfesores(alumno.cvu);
          alumno.valido = !profesores.some(
            profesor =>
              profesor.cvuAlumno == alumno.cvu &&
              profesor.claveRelacion == alumno.relacion.clave &&
              profesor.cvuProfesor != this.participacionProfesor.participante.cvu
          );

          if (!alumno.valido) {
            this.alertService().showError(
              this,
              this.$t('apeironGwApp.claustroSnp.modalAsociar.errorAsociacion', { cvuAlumno: alumno.cvu }).toString()
            );
          }
        } catch (error) {
          alumno.valido = false;
        }
      });

    await Promise.all(validaciones);
  }

  /**
   * Obtiene la participación del profesor en la solicitud
   * @returns El objeto de participación del profesor
   */
  public obtenerProfesor(): Promise<ParticipacionProfesorSnp> {
    return new Promise<ParticipacionProfesorSnp>((resolve, reject) => {
      const filtroPart: FiltroParticipacion = {
        solicitudId: this.solicitud.id,
        rol: RolAutoridad.PROFESOR,
        participacionId: this.participacionProfesor.id,
      };
      const paginationQuery = {
        page: 0,
        size: 1,
        sort: ['id,desc'],
        filter: filtroPart,
      };
      this.participanteService()
        .obtenerParticipaciones(paginationQuery)
        .then(res => {
          resolve(ParticipacionProfesorSnp.fromObject(res.data[0]));
        })
        .catch(err => reject(err));
    });
  }

  public checarEstado(alumno: Alumno): boolean {
    return this.esEscritura
      ? alumno.asociado && alumno.relacion
        ? true
        : alumno.asociado && !alumno.relacion
        ? false
        : undefined
      : undefined;
  }

  public eliminarRelacion(alumno: Alumno): void {
    alumno.relacion = undefined;
    alumno.asociado = false;
    this.$forceUpdate();
  }

  /**
   * Obtiene los profesores que tienen relacionado al alumno en la solicitud.
   *
   * @param cvuAlumno alumno del cual se van a buscar los profesores
   * @returns lista de participaciones de profesores
   */
  private obtenerProfesores(cvuAlumno: string): Promise<Array<ProfesorAlumnoSnp>> {
    return new Promise<Array<ProfesorAlumnoSnp>>((resolve, reject) => {
      this.participanteService()
        .obtenerRelacionesAlumno(this.solicitud.id, cvuAlumno)
        .then(res => {
          const profesores: Array<ProfesorAlumnoSnp> = [];
          (res.data ?? []).forEach(profesor => {
            profesores.push(profesor);
          });
          resolve(profesores);
        })
        .catch(err => reject(new Error(err)));
    });
  }

  @Emit('change')
  public emitirCambio(): number {
    return 1;
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }
}
